interface Props {
  val: string;
  len: number;
  onChange: (val: string) => void;
  disabled?: boolean;
}

/**
 * 数値文字列入力フィールド
 * @param props
 * @returns
 */
const InputNumText = ({ val, len, onChange, disabled }: Props) => {
  return (
    <input
      type="text"
      value={val}
      pattern={`[0-9]{${len}}`}
      maxLength={len}
      size={len}
      onChange={e => onChange(e.target.value.replace(/[^0-9]/g, ""))}
      required
      disabled={disabled}
    />
  );
};
export default InputNumText;
